module.exports = __webpack_public_path__ + "img/weSite.ea7502c4.png";